import LazyLoad from "react-lazyload";
import { Link } from 'react-router-dom'
const Contact = () => {
    return (
        <>
            <div className="breadcrumb">
                <h2>Contact Us</h2>
                <ul>
                    <li><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link></li>
                    <li>|</li>
                    <li>Contact Us</li>
                </ul>
            </div>
            <div className="inner_page">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                           <div className="cont-blk">
                            <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/mail.png" className="img-fluid" alt="St Francis School, Amritsar" /></LazyLoad>
                            <div>
                                <h3>E-MAIL US</h3>
                                <p><a href="mailto:stfrancisasr@gmail.com" target="_blank">stfrancisasr@gmail.com</a></p>

                            </div>
                           </div>
                           <div className="cont-blk">
                           <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/contact.png" className="img-fluid" alt="St Francis School, Amritsar" /></LazyLoad>
                            <div>
                                <h3>LET'S TALK</h3>
                                <p><a href="tel:98152-13457" target="_blank">98152-13457</a></p>

                            </div>
                           </div>
                           <div className="cont-blk">
                            <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/loc.png" className="img-fluid" alt="St Francis School, Amritsar" /></LazyLoad>
                            <div>
                                <h3>Address Details</h3>
                                <p>31, Cantonment, Railway Estate Colony, Canal Colony, Amritsar, Punjab 143001</p>

                            </div>
                           </div>
                        </div>
                        <div className="col-lg-6">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3396.8792601075534!2d74.85321831515348!3d31.637156081331153!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391964af081f8b0f%3A0xdad4ee7e3e7bbf1a!2sSt%20Francis%20School!5e0!3m2!1sen!2sin!4v1646713133282!5m2!1sen!2sin"  allowfullscreen="" loading="lazy"></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Contact
